import { useSeoMeta } from '@unhead/react';
import { SiteHeader } from '@/components/landing/SiteHeader';
import { Hero } from '@/components/landing/Hero';
import { Marquee } from '@/components/landing/Marquee';
import { About } from '@/components/landing/About';
import { Tracks } from '@/components/landing/Tracks';
import { Schedule } from '@/components/landing/Schedule';
import { Prizes } from '@/components/landing/Prizes';
import { Faq } from '@/components/landing/Faq';
import { Rsvp } from '@/components/landing/Rsvp';
import { SiteFooter } from '@/components/landing/SiteFooter';

const Index = () => {
  useSeoMeta({
    title: 'SheSats Nairobi — Bitcoin & Nostr Hackathon for Women',
    description:
      'A free two-day Bitcoin & Nostr hackathon for women in Nairobi, Kenya. Learn, build, and ship with sats — 14–15 November 2026. No experience needed.',
    ogTitle: 'SheSats Nairobi — Bitcoin & Nostr Hackathon for Women',
    ogDescription:
      'Two days of building on Bitcoin & Nostr, for women, in Nairobi. Free to attend, 2.1M sats in prizes. 14–15 November 2026.',
    ogType: 'website',
    twitterCard: 'summary_large_image',
  });

  return (
    <div className="min-h-screen bg-background font-sans text-foreground">
      <SiteHeader />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Tracks />
        <Schedule />
        <Prizes />
        <Faq />
        <Rsvp />
      </main>
      <SiteFooter />
    </div>
  );
};

export default Index;
